import React from 'react';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
import { Box, Button, Link, ListItem, ListItemAvatar, ListItemText, Typography} from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const forms = [
    {
      title: 'Organization Form CPF 101',
      subtitle:
        'Statement of Organization Form for candidates and committees to register with OCPF',
      icon: (
        <AccountBalanceIcon fontSize="large" />
      ),
      link: 'https://ocpf2.blob.core.windows.net/pdf/forms/cpf_101_new.pdf'
    },
    {
      title: 'Appointment of Depository CPF D103',
      subtitle:
        "Bank Form to be filled out by the committee's depository bank",
      icon: (
        <CreditCardIcon fontSize="large" />
      ),
      link: 'https://ocpf2.blob.core.windows.net/pdf/forms/cpf_d103.pdf'
    },
    {
      title: 'Changing Treasurer Form CPF T101',
      subtitle:
        'Change of Treasurer Form to appoint a new treasurer',
      icon: (
        <AccountCircleIcon fontSize="large" />
      ),
      link: 'https://ocpf2.blob.core.windows.net/pdf/forms/cpft101_2018.pdf?'
    },
  ];

const FeaturedForms = (): JSX.Element => {

    const theme = useTheme();

    return (
    <Box marginTop={3} marginBottom={4}>
        <Box marginBottom={4}>
        <Typography
          variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          fontWeight={700}
          data-aos={'fade-up'}
          gutterBottom
          color={'secondary'}
          align={'center'}
        >
          Frequently Requested Forms
        </Typography>
      </Box>
      <Grid container spacing={4}>
        {forms.map((item, i) => (
          <Grid key={i} size={{xs:12, md:4}}>
            <ListItem
              component={Link}
              href={item.link}
              target={'_blank'}
              disableGutters
              className='is-clickable'
              data-aos={'fade-up'}
              data-aos-delay={i * 100}
              data-aos-offset={100}
              data-aos-duration={600}
              sx={{
                flexDirection: 'column',
                alignItems: 'center',
                padding: 0,
              }}
            >
              <Box
                component={ListItemAvatar}
                marginBottom={1}
                minWidth={'auto !important'}
              >
                <Box color={'primary.ocpfBlue'}>{item.icon}</Box>
              </Box>
              <ListItemText
                primary={item.title}
                secondary={item.subtitle}
                primaryTypographyProps={{
                  variant: 'h6',
                  gutterBottom: true,
                  align: 'center',
                }}
                secondaryTypographyProps={{ align: 'center' }}
                sx={{
                  '& .MuiListItemText-primary': {
                    fontWeight: 700,
                  },
                  margin: 0,
                }}
              />
            </ListItem>
          </Grid>
        ))}
      </Grid>
        <Box marginTop={3} display={'flex'} justifyContent={'center'}>
            <Button
              aria-label='view all forms'
              title='view all forms'  
              variant="outlined"
              color="primary"
              size="large"
              component={Link}
              data-aos={'fade-up'}
              href='/Publications/Forms'
            >
              View All Forms
            </Button>
          </Box>
    </Box>
    )

}

export default FeaturedForms;